/** Dispatched on window when map (or other UI) should close open SearchableSelect menus */
export const SLV_CLOSE_SEARCHABLE_SELECT_EVENT = "slv-close-searchable-select";
